import AddTemplate from "../_templates/AddTemplate";
import { stadiumSchema } from "../../../schemas/stadium.schema";
import { createStadium } from "../../../api/coredata.api";

export default function AddStadium() {
  return (
    <AddTemplate
      title="Add Stadium"
      schema={stadiumSchema}
      createFn={createStadium}
      redirectPath="/cricket/stadiums"
    />
  );
}
